import "./Thanks.css";
import thankImage from "../assets/Tha.jpeg";

function Thanks() {
    return (
        <section className="thanks-section" id="thanks">
            <div className="thanks-container">

                <div className="thanks-content">
                    <h1>
                        Thank you
                        <br />
                        for visiting us.
                    </h1>

                    <p>
                        Before you leave, we would love to know
                        <br />
                        how you discovered <strong>THAI NURSERY</strong>.
                    </p>

                    <button>COMMENTS</button>
                </div>

            </div>

            <div className="thanks-image">
                <img src={thankImage} alt="Thai Nursery" />
            </div>
        </section>
    );
}

export default Thanks;